var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { Translate } from '../../utils/translate.js';
let CardButtonComponent = class CardButtonComponent extends GGOBaseComponent {
    constructor() {
        super(...arguments);
        this.title = '';
        this.icon = '';
        this.bgColor = '';
    }
    static get styles() {
        return [
            ...super.styles,
            css `
        .slds-card {
          border-radius: 0.5rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          background: #fff;
          padding: 0.5rem;
          display: flex;
          flex-direction: column;
          min-width: 250px;
          max-width: 350px;
        }
        .slds-card__header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }
        .slds-card__icon {
          font-size: 2rem;
          margin-right: 0.75rem;
        }
        .slds-card__title {
          font-size: 1.25rem;
          font-weight: 600;
          color: #03234d;
        }
        .slds-card__body {
          flex: 1;
          margin-bottom: 1rem;
          color: #444;
          text-align: left;
          margin-left: 1rem;
          margin-top: 0;
          font-size: .85rem;
        }
        .slds-card__footer {
          display: flex;
          justify-content: flex-end;
          border-top: none !important;
        }
        .slds-button {
          background: #0070d2;
          color: #fff;
          border: none;
          border-radius: 0.25rem;
          padding: 0.5rem 1.25rem;
          font-size: 1rem;
          cursor: pointer;
          transition: background 0.2s;
        }
        .slds-button:hover {
          background: #005fb2;
        }
        .slds-card:hover {
          box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.16);
        }
      `,
        ];
    }
    firstUpdated(_changedProperties) {
        if (this.bgColor && this.bgColor.length > 0) {
            const cardBody = this.shadowRoot?.querySelector('.slds-card');
            if (cardBody) {
                cardBody.style.backgroundColor = this.bgColor;
            }
        }
    }
    render() {
        // Get the height from the component's style attribute if specified
        const height = this.style.height ? `height: ${this.style.height};` : '';
        const width = this.style.width ? `width: ${this.style.width};` : '';
        return html `
      <div class="slds-card" style="${height} ${width}">
        <div class="slds-card__header">
          <span class="slds-card__icon">
            <ggo-icon icon="${this.icon}"></ggo-icon>
          </span>
          <span class="slds-card__title">${this.title}</span>
        </div>
        <div class="slds-card__body"><slot></slot></div>
        <div class="slds-card__footer">
          <ggo-button variant="action" @click=${this._onStartClick}>${Translate.get('card_button_start')}</ggo-button>
        </div>
      </div>
    `;
    }
    _onStartClick() {
        this.dispatchEvent(new CustomEvent('start', { bubbles: true, composed: true }));
    }
};
__decorate([
    property({ type: String })
], CardButtonComponent.prototype, "title", void 0);
__decorate([
    property({ type: String })
], CardButtonComponent.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], CardButtonComponent.prototype, "bgColor", void 0);
CardButtonComponent = __decorate([
    customElement('ggo-card-button')
], CardButtonComponent);
export { CardButtonComponent };
